import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';
import { BLACK } from 'root/theme';
import media from '../../oldpantheon/utils/media';

export const InfoTitle = styled.div`
  font-size: 1.5rem;
  color: ${BLACK};
  font-family: "Calistoga";
  margin-bottom: 0.9rem;
  text-align: ${(props) => props.center ? `center` : `left`};
`;

export const ChosenSigns = styled.div`
  font-family: "PT Serif";
  font-size: 1.25rem;
  text-align: center;
  margin-top: 2.2rem;
`;

export const ChosenSignImg = styled(InlineSVG)`
  width: 9.375rem;
  height: auto;

  ${media.extraSmall`
    width: 6.25rem;
    height: auto;
    `}
`;

export const CompatibilityInfo = styled.div`
  line-height: 1.75rem;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  color: ${BLACK};
`;

export const CompatibilityIconSimple = styled.img`
  padding: 0 0.9rem;
`;

export const SignImagesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
